export default __webpack_public_path__ + "static/media/GreenLand.001a9256.png";